import { AloftArea, isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectCompSequence } from './orderSelectors.ts';
import { selectSiteEntities } from './propertyDataSelectors/siteSelectors.ts';

const calculateSiteSize = (siteEntities: ReturnType<typeof selectSiteEntities>, id: string) => {
  const siteArea = siteEntities[id]?.area;
  if (isUndefined(siteArea)) return undefined;

  return AloftArea.schema.parse(siteArea).toSqFt();
};

export const selectSiteSizes = createSelector(
  [selectSiteEntities, selectCompSequence],
  (siteEntities, compSequence) => {
    const properties = ['subject', ...compSequence];

    return Object.fromEntries(
      properties.map((propID) => [propID, calculateSiteSize(siteEntities, propID)]),
    );
  },
);
